import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../authContext/StoreContext";
import FollowTheSignsIcon from "@mui/icons-material/FollowTheSigns";
import { useSnackbar } from "notistack";
import api from "../hooks/apiClient";
import { useSocket } from "../hooks/useSocket";
import PhonelinkRingIcon from "@mui/icons-material/PhonelinkRing";
import PhonelinkEraseIcon from "@mui/icons-material/PhonelinkErase";
import { CircularProgress } from "@mui/material";
const StoreSelector = ({ setUnread }) => {
  const { enqueueSnackbar } = useSnackbar();
  const {
    selectedStore,
    selectedDestStore,
    updateSelectedStore,
    updateSelectedDestStore,
    isStoreSelected,
  } = useStore();
  const { socket, isConnected, status } = useSocket();

  const [storesData, setStoresData] = useState([]);
  const [dStoresData, setDStoresData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch stores data
  const fetchStores = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.get("stores/active");
      setStoresData(response.data.source || []);
      setDStoresData(response.data.destination || []);
    } catch (err) {
      setError("Failed to load stores");
      console.error("Error fetching stores:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isStoreSelected) {
      fetchStores();
    }
  }, [selectedStore]);
  useEffect(() => {
    const handleCSNotification = (data) => {
      enqueueSnackbar(`CS Alert: ${data.message} from ${data.from}`, {
        variant: "success",
      });
      setUnread((prev) => prev + 1);
    };
    socket.on("cs_notification", handleCSNotification);
    return () => {
      socket.off("cs_notification", handleCSNotification);
    };
  }, [socket]);

  const handleStoreChange = (storeType, selectedId) => {
    const dataSource = storeType === "source" ? storesData : dStoresData;
    const selectedStore = dataSource.find(
      (s) => s.id.toString() === selectedId,
    );

    if (selectedStore) {
      updateSelectedStore({
        id: selectedStore.id,
        public_name: selectedStore.public_name,
        type: storeType,
        isActive: selectedStore.isActive,
        phoneID: selectedStore.sms_device,
      });
    }
    if (selectedStore && storeType === "destination") {
      updateSelectedDestStore({
        id: selectedStore.id,
        public_name: selectedStore.public_name,
        type: storeType,
        isActive: selectedStore.isActive,
      });
    }
  };

  if (loading) return <div className="text-center py-2">Loading stores...</div>;
  if (error) return <div className="text-danger py-2">{error}</div>;

  return (
    <div className="d-flex justify-content-between p-1 border-bottom border-info">
      <div className="">
        {selectedStore && (
          <span className="badge bg-primary p-2">
            {selectedStore.public_name}
          </span>
        )}
        <span component="div" sx={{ flexGrow: 1 }}>
          {/* {isConnected ? <PhonelinkRingIcon /> : <PhonelinkEraseIcon />} */}
          {status === "connected" && <PhonelinkRingIcon />}
          {status === "connecting" && <CircularProgress size={18} />}
          {status === "disconnected" && <PhonelinkEraseIcon />}
        </span>
      </div>

      <div className="d-flex gap-2">
        <FollowTheSignsIcon />

        <button
          onClick={fetchStores}
          className="btn btn-sm btn-outline-secondary"
          disabled={loading}
        >
          {loading ? "Refreshing..." : "Refresh "}
        </button>

        <select
          className="form-select form-select-sm"
          value={selectedStore?.type === "source" ? selectedStore.id : ""}
          onChange={(e) => handleStoreChange("source", e.target.value)}
          disabled={storesData.length === 0}
        >
          <option value="">Select Source Store</option>
          {storesData.map((store) => (
            <option key={`source-${store.id}`} value={store.id}>
              {store.public_name}
            </option>
          ))}
        </select>

        <select
          className="form-select form-select-sm"
          value={selectedStore?.type === "destination" ? selectedStore.id : ""}
          onChange={(e) => handleStoreChange("destination", e.target.value)}
          disabled={dStoresData.length === 0}
        >
          <option value="">Select Destination Store</option>
          {dStoresData.map((store) => (
            <option key={`dest-${store.id}`} value={store.id}>
              {store.public_name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default StoreSelector;
